module.exports = __webpack_public_path__ + "img/time@2x.8029eb3.webp";